<template>
  <div class="ProfileCount">
    <span>{{ object.count }}</span>
    <span v-if="!object.userCanUpdate" :title="$t('profile.errors.user_has_no_dati_visibility')">
        <i class="ml-1 fa fa-lock"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: 'ProfileCount',
  props: ['object'],
}
</script>

<style lang="scss" scoped>

</style>
  